(function () {
  'use strict';

  var lastTrigger = null;

  function closeDialog(dialog) {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      dialog.hidden = true;
      if (lastTrigger) lastTrigger.focus();
    }
  }

  function initialize() {
    var triggers = document.querySelectorAll('[data-ers-research-dialog-open]');

    Array.prototype.forEach.call(triggers, function (trigger) {
      var dialog = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!dialog) return;

      trigger.addEventListener('click', function () {
        lastTrigger = trigger;
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.hidden = false;
          dialog.setAttribute('open', '');
        }
        var closeButton = dialog.querySelector('[data-ers-research-dialog-close]');
        if (closeButton) closeButton.focus();
      });

      Array.prototype.forEach.call(dialog.querySelectorAll('[data-ers-research-dialog-close]'), function (button) {
        button.addEventListener('click', function () {
          closeDialog(dialog);
        });
      });

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeDialog(dialog);
      });

      dialog.addEventListener('close', function () {
        if (lastTrigger) lastTrigger.focus();
      });

      dialog.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && typeof dialog.close !== 'function') {
          event.preventDefault();
          closeDialog(dialog);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
}());
